import cx from 'classnames';
import styled from 'styled-components';
const FrameRoot = styled.div `
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: clamp(1.25rem, 7.8125vw, 2.5rem) clamp(1.25rem, 6.25vw, 2rem);
    background: var(--tv-ui-color-19);
    backdrop-filter: blur(5rem);
    -webkit-backdrop-filter: blur(5rem);
`;
export const Frame = styled(FrameRoot).attrs(({ className }) => ({
    className: cx('tv-ui-shiny-border', className),
})) ``;
